import AdminClient from '../client/AdminClient';
import _ from "lodash";
import {mapIds} from "../../../helpers/utils";

class EmailValidationService {
    static emailValidationEndpoint = '/v1/admin/email_checks';

    static async validations(session, params) {
        const filterParams = this.parsedFilterParams(params.filterParams);
        if (typeof params.filter === 'string') {
            params.filter = params.filter.trim();
        }
        return AdminClient.get(`${this.emailValidationEndpoint}`, session,
            {
                ...params,
                filterParams: filterParams,
            }
        );
    }

    static async override(validationId, session, status) {
        return AdminClient.put(`${this.emailValidationEndpoint}/${validationId}/override`, session, {status: status});
    }

    static async review(validationId, session) {
        return AdminClient.put(`${this.emailValidationEndpoint}/${validationId}/review`, session);
    }

    static parsedFilterParams(params) {
        if (!_.isEmpty(params)) {
            return {
                ...params,
                statuses: mapIds(params.statuses || []),
                subStatuses: mapIds(params.subStatuses || []),
                flagStatus: mapIds(params.flagStatus || []),
            }
        } else {
            return params;
        }
    }
}

export default EmailValidationService;